<div
    class="animate-fade-in w-100vw fixed top-0 right-0 left-0 z-1000 h-full"
    [class.backdrop-blur]="blur()"
    cdkTrapFocus
    cdkTrapFocusAutoCapture
>
    <div
        class="absolute top-0 left-0 h-full w-full bg-black-{{ blackOpacityPercentage() }}"
        [class.backdrop-blur]="blur()"
        (click)="closeDialog(); $event.stopPropagation()"
    ></div>
    <ng-content />
</div>
